<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">{{ formTitle }}</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout text-center">
                <div class="md-layout-item md-size-100 md-xsmall-size-100">
                  <div class="md-layout">
                    <!-- Avatar -->
                    <div
                      class="md-layout-item md-size-100 md-xsmall-size-100"
                      id="new-avatar"
                    >
                      <h4 class="card-title">
                        {{ $t("news.avatar") }}
                      </h4>
                      <div class="file-input img-circle">
                        <template v-if="!imageCircle">
                          <div class="image-fix-container">
                            <img :src="avatarImg" title="" alt="" />
                          </div>
                        </template>
                        <div class="image-fix-container" v-else>
                          <img :src="imageCircle" alt="" />
                        </div>
                        <div class="button-container">
                          <md-button
                            class="md-success md-round md-fileinput"
                            @click="onFileChange"
                          >
                            <template v-if="!imageCircle"
                              >{{ $t("news.add_avatar") }}
                            </template>
                            <template v-else
                              >{{ $t("news.change_avatar") }}
                            </template>
                          </md-button>
                        </div>
                      </div>
                    </div>

                    <!-- Left  -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <!--   title    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('news.title')"
                            >
                              {{ $t("news.title") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('news.title')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input v-model="params.title" type="text">
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   news category id   -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('news.category_name')"
                            >
                              {{ $t("news.category_name") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('news.category_name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-select
                                    v-model="params.news_category_id"
                                    :name="$t('news.category_name')"
                                  >
                                    <md-option
                                      :value="option.id"
                                      v-for="option in news_categories"
                                      :key="option.id"
                                      >{{ option.name }}
                                    </md-option>
                                  </md-select>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Right  -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <!--   Description    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('news.description')"
                            >
                              {{ $t("news.description") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('news.description')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.description"
                                    type="text"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Content  -->
                    <div class="md-layout-item md-size-100 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-10 md-xsmall-size-100  md-form-label required-field"
                          :for="$t('news.content')"
                          style="padding-left: 10px;"
                        >
                          {{ $t("news.content") }}
                        </label>
                        <div
                          class="md-layout-item md-size-90 md-xsmall-size-100"
                        >
                          <ValidationProvider
                            :name="$t('news.content')"
                            rules="required"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                              class="ckeditor-field"
                            >
                              <div style="width: 100%">
                                <ckeditor
                                  @ready="onReady"
                                  :editor="editor"
                                  v-model="params.content"
                                  :config="editorConfig"
                                ></ckeditor>
                              </div>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close
                                </md-icon>
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done
                                </md-icon>
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>

            <md-card-actions class="text-center">
              <md-button type="submit" class="md-success"
                >{{ $t("common.save") }}
              </md-button>
              <md-button native-type="button" @click="cancel"
                >{{ $t("common.cancel") }}
              </md-button>
            </md-card-actions>
          </md-card>
        </form>
      </ValidationObserver>
    </div>
    <!--  Avatar  -->
    <crop-upload-image-modal
      :modal-data="modalAvatar"
      :origin-img-src="imageCircle"
      :min-container-width="320"
      :min-container-height="180"
      :background="true"
      :rotatable="false"
      :img-style="{ width: '320px', height: '180px' }"
      :aspect-ratio="16 / 9"
      :click-outside-to-close="false"
      @closeModal="closeModalChangeAvatar"
      @setCroppedImageSrc="updateAvatar"
    ></crop-upload-image-modal>
  </div>
</template>

<script>
import sanitizer from "sanitizer";
import { NewsService } from "../../services/news.service";
import { NewsCategoriesService } from "../../services/newsCategories.service";
import queryHelper from "@/helpers/query-helper";
import CropUploadImageModal from "../../components/VueUploadMultipleImage/CropUploadImageModal";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import CkeditorUploadAdapter from "@/helpers/ckeditor-upload-adapter";
export default {
  name: "NewsCreateForm",
  components: { CropUploadImageModal },
  props: {
    id: {},
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formTitle: this.$t("page_title.news_create"),
      defaultAvatarFile: null,
      avatarFile: null,
      editor: DecoupledEditor,
      editorConfig: {
        fontSize: {
          options: [
            8,
            9,
            10,
            11,
            12,
            13,
            "default",
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            24,
            26,
            28,
            36,
            48
          ],
          supportAllValues: true
        },
        extraPlugins: [this.uploader],
        language: "vi"
      },
      avatarImg: "../img/image_placeholder.jpg",
      modalAvatar: {
        show: false,
        action: "create"
      },
      imageCircle: "",
      params: {
        title: null,
        description: null,
        avatar: null,
        news_category_id: null,
        content: null
      },
      news_categories: []
    };
  },
  watch: {
    id(newVal) {
      this.getDetailNews(newVal);
    }
  },
  mounted() {
    if (this.editMode) {
      this.getDetailNews(this.id);
    }
  },
  methods: {
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    async getDetailNews(id) {
      const info = await new NewsService().getById(id);
      this.params.title = info.title;
      this.params.content = info.content;
      this.params.description = info.description;
      this.params.news_category_id = info.news_category_id;
      this.params.avatar = info.avatar;

      //  get avatar image
      if (info.avatar !== null && info.avatar !== "") {
        this.imageCircle = info.avatar;
      }
    },
    changeFile(name, files) {
      if (name === "avatar") {
        this.avatarFile = files[0];
      }
    },
    cancel() {
      this.$router.push({ name: "NewsList" });
    },
    async submit() {
      let formData = this.buildFormDataCreateNews();
      if (this.editMode) {
        await this.updateNews(this.id, formData);
        return;
      }
      await this.createNews(formData);
    },
    async createNews(formData) {
      const response = await new NewsService().create(formData);
      if (!response) return;
      this.$notify({
        title: this.$t("common.created"),
        text: this.$t("common.created_text", {
          name: this.$t("news.title"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
      setTimeout(() => this.$router.push({ name: "NewsList" }), 500);
    },
    async updateNews(id, formData) {
      const response = await new NewsService().update(id, formData);
      if (!response) return;
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_text", {
          name: this.$t("news.title"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
    },
    async getNewsCategories() {
      const response = await new NewsCategoriesService().getList({
        limit: 1000
      });
      this.news_categories = response.data || [];
      return response.data;
    },
    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new CkeditorUploadAdapter(loader);
      };
    },
    buildFormDataCreateNews() {
      let params = this.params;
      if (this.editMode) {
        params._method = "PUT";
      }
      return queryHelper.buildFormData(params);
    },
    closeModalChangeAvatar() {
      this.modalAvatar.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    showModalChangeAvatar(action) {
      this.modalAvatar.action = action || "create";
      this.modalAvatar.show = true;
      this.$store.commit("SHOW_MODAL");
    },
    onFileChange(e) {
      this.showModalChangeAvatar("edit");
    },
    updateAvatar(file) {
      this.params.avatar = file;
      this.createImage(file, "circle");
    },
    createImage(file, type) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        if (type === "circle") {
          vm.imageCircle = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    }
  },
  created() {
    this.getNewsCategories();
  }
};
</script>

<style scoped lang="scss">
#new-avatar {
  margin-bottom: 30px;
  .file-input.img-circle {
    max-width: 250px;
  }
  .image-fix-container {
    max-width: 250px;
  }
}
</style>
